// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import WidgetReservationListModel from '../../model/widget-reservation-list-model';
import WidgetReservationListDTO from '../dto/widget-reservation-list-dto';
import dtoSchema from '../schemas/widget-reservation-list-schema';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class WidgetReservationListModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<WidgetReservationListDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.eventName = data.eventName ?? undefined;
      this.startDate = data.startDate ?? undefined;
      this.endDate = data.endDate ?? undefined;
      this.rooms = data.rooms ?? undefined;
      this.lecturers = data.lecturers ?? undefined;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  eventName?: string;
  /**
  * @type {date-time}
  */
  startDate?: string;
  /**
  * @type {date-time}
  */
  endDate?: string;
  /**
  */
  rooms?: string[];
  /**
  */
  lecturers?: string[];

  static toModel(dto: DeepPartial<WidgetReservationListDTO>): WidgetReservationListModel;
  static toModel(dto: DeepPartial<WidgetReservationListDTO> | undefined | null): WidgetReservationListModel | undefined;
  static toModel(dto: DeepPartial<WidgetReservationListDTO> | undefined | null): WidgetReservationListModel | undefined {
    return dto ? new WidgetReservationListModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<WidgetReservationListModel> | WidgetReservationListModel): WidgetReservationListDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      eventName: unwrapped.eventName,
      startDate: unwrapped.startDate,
      endDate: unwrapped.endDate,
      rooms: unwrapped.rooms,
      lecturers: unwrapped.lecturers,
    } as WidgetReservationListDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for WidgetReservationListModel, can not map to WidgetReservationListDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
